var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c(_vm.activeNavigation,{tag:"component",attrs:{"player":_vm.player},on:{"updateSkill":_vm.updateSkill}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }